import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import { disposeModal } from "../../utils/modal-dispose.util"

// Shows trial welcome modal on connect. User can dismiss via close button,
// backdrop click, or Escape — revealing the plans page underneath.
export default class extends Controller {
  connect() {
    this.modal = new Modal(this.element, {
      backdrop: true,
      keyboard: true
    })
    this.modal.show()
  }

  disconnect() {
    disposeModal(this.modal)
  }
}
